import {Component, OnInit, ViewChild} from '@angular/core';
import {MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {MatButton} from '@angular/material/button';
import {MatDialogActions, MatDialogContent} from '@angular/material/dialog';
import {FilterPanelComponent} from '@app/assetfilter/filter-panel/filter-panel.component';
import {FilterPanelComponent as FilterPanelComponent_1} from '../filter-panel/filter-panel.component';

@Component({
    selector: 'frog-filters-sheet',
    templateUrl: './filters-sheet.component.html',
    styleUrls: ['./filters-sheet.component.scss'],
    imports: [MatDialogContent, FilterPanelComponent_1, MatDialogActions, MatButton],
})
export class FiltersSheetComponent implements OnInit {
    @ViewChild(FilterPanelComponent) filterPanel;

    constructor(private bottomSheetRef: MatBottomSheetRef<FiltersSheetComponent>) {}

    ngOnInit(): void {}

    apply() {
        this.filterPanel.apply();
        this.bottomSheetRef.dismiss();
    }

    clear() {
        this.filterPanel.clear();
        this.bottomSheetRef.dismiss();
    }
}
